<template>
    <div class="dashboard">
        <h1>車両点検</h1>
        <div class="l-5-10-m--all">
            <div>
                <input v-model="params.month" type="month" @change="fetchingListVehicleInspections()">
            </div>
            <div>
                <select v-model="params.id" @change="fetchingListVehicleInspections()">
                    <option v-for="(data, key) in listVehicles" :key="key" :value="data.vehicle_id">{{ data.vehicle_id }}</option>
                </select>
            </div>
            <div>
                &nbsp;
            </div>
            <div>
                &nbsp;
            </div>
            <div>
                &nbsp;
            </div>
        </div>
        <div class="l-mb4 l-5-10-m--all">
            <div>
                <select v-model="stamp.plantManager">
                    <option value="mizutani">工場長：水谷</option>
                    <option value="watanabe">工場長：渡辺</option>
                </select>
            </div>
            <div>
                <select v-model="stamp.sectionChief1">
                    <option value="mizutani">課長：水谷</option>
                    <option value="watanabe">課長：渡辺</option>
                </select>
            </div>
            <div>
                <select v-model="stamp.sectionChief2">
                    <option value="mizutani">係長：水谷</option>
                    <option value="watanabe">係長：渡辺</option>
                </select>
            </div>
            <div>
                &nbsp;
            </div>
            <div>
                <button class="button--oval--other" type="button" @click="pdfDownload()">
                    PDFダウンロード
                </button>
            </div>
        </div>
        <table>
            <tr>
                <th>車両の周り 灯火装置・方向指示器</th>
                <th v-for="i of lastDay" :key="i" class="is-center">
                    <template v-if="listVehicleInspectionsDate[`${params.month}-${('0' + i).slice(-2)}`][tableSet.dateItem01[0].key] !== ''">
                        <button class="button--date" @click="goToUpdate(i)">
                            {{ i }}
                        </button>
                    </template>
                    <template v-else>
                        {{ i }}
                    </template>
                </th>
            </tr>
            <tr v-for="(item, index) in tableSet.dateItem01" :key="`item${index}`">
                <td>
                    {{ item.head }}
                </td>
                <td v-for="(list, key) in listVehicleInspectionsDate" :key="`item${index}list${key}`" class="is-center">
                    {{ list[item.key] | changeFormatValue }}
                </td>
            </tr>
        </table>
        <table>
            <tr>
                <th>タイヤ</th>
                <th v-for="i of lastDay" :key="i" class="is-center">
                    {{ i }}
                </th>
            </tr>
            <tr v-for="(item, index) in tableSet.dateItem02" :key="`item${index}`">
                <td>
                    {{ item.head }}
                </td>
                <td v-for="(list, key) in listVehicleInspectionsDate" :key="`item${index}list${key}`" class="is-center">
                    {{ list[item.key] | changeFormatValue }}
                </td>
            </tr>
        </table>
        <table>
            <tr>
                <th>エア・タンク</th>
                <th v-for="i of lastDay" :key="i" class="is-center">
                    {{ i }}
                </th>
            </tr>
            <tr v-for="(item, index) in tableSet.dateItem03" :key="`item${index}`">
                <td>
                    {{ item.head }}
                </td>
                <td v-for="(list, key) in listVehicleInspectionsDate" :key="`item${index}list${key}`" class="is-center">
                    {{ list[item.key] | changeFormatValue }}
                </td>
            </tr>
        </table>
        <table>
            <tr>
                <th>積載</th>
                <th v-for="i of lastDay" :key="i" class="is-center">
                    {{ i }}
                </th>
            </tr>
            <tr v-for="(item, index) in tableSet.dateItem07" :key="`item${index}`">
                <td>
                    {{ item.head }}
                </td>
                <td v-for="(list, key) in listVehicleInspectionsDate" :key="`item${index}list${key}`" class="is-center">
                    {{ list[item.key] | changeFormatValue }}
                </td>
            </tr>
        </table>
        <table>
            <tr>
                <th>運転席 ブレーキ</th>
                <th v-for="i of lastDay" :key="i" class="is-center">
                    {{ i }}
                </th>
            </tr>
            <tr v-for="(item, index) in tableSet.dateItem04" :key="`item${index}`">
                <td>
                    {{ item.head }}
                </td>
                <td v-for="(list, key) in listVehicleInspectionsDate" :key="`item${index}list${key}`" class="is-center">
                    {{ list[item.key] | changeFormatValue }}
                </td>
            </tr>
        </table>
        <table>
            <tr>
                <th>原動機</th>
                <th v-for="i of lastDay" :key="i" class="is-center">
                    {{ i }}
                </th>
            </tr>
            <tr v-for="(item, index) in tableSet.dateItem05" :key="`item${index}`">
                <td>
                    {{ item.head }}
                </td>
                <td v-for="(list, key) in listVehicleInspectionsDate" :key="`item${index}list${key}`" class="is-center">
                    {{ list[item.key] | changeFormatValue }}
                </td>
            </tr>
        </table>
        <table>
            <tr>
                <th>&nbsp;</th>
                <th v-for="i of lastDay" :key="i" class="is-center">
                    {{ i }}
                </th>
            </tr>
            <tr v-for="(item, index) in tableSet.dateItem06" :key="`item${index}`">
                <td>
                    {{ item.head }}（千km）
                </td>
                <td v-for="(list, key) in listVehicleInspectionsDate" :key="`item${index}list${key}`" class="is-center" style="font-size: 11px;">
                    {{ list[item.key] | changeFormatMileage }}
                </td>
            </tr>
        </table>
        <table class="l-mt4" style="width: 48.9%">
            <tr>
                <th style="width: 34.9%">&nbsp;</th>
                <th v-for="i of 12" :key="i" class="is-center">
                    <template v-if="`${params.month.slice(0, 4)}-${('0' + i).slice(-2)}` in listVehicleInspectionsMonth && listVehicleInspectionsMonth[`${params.month.slice(0, 4)}-${('0' + i).slice(-2)}`][tableSet.month[0].key] !== ''">
                        <button class="button--date" @click="goToUpdateMonth(i)">
                            {{ i }}
                        </button>
                    </template>
                    <template v-else>
                        {{ i }}
                    </template>
                </th>
            </tr>
            <tr v-for="(item, index) in tableSet.month" :key="`item${index}`">
                <td style="width: 34.9%">
                    {{ item.head }}
                </td>
                <td v-for="(list, key) in listVehicleInspectionsMonth" :key="`item${index}list${key}`" class="is-center">
                    {{ list[item.key] | changeFormatValue }}
                </td>
            </tr>
        </table>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";
    import pdf from "@/mixins/pdf";
    import sorts from "@/mixins/sort";
    import { stamp } from "@/assets/scripts/stamp.js";

    const tableVehicleInspectionsDate01 = [
        {
            "head": "点灯又は点滅具合、汚れ・破損",
            "key": "lighting_or_blinking",
        },
    ];

    const tableVehicleInspectionsDate02 = [
        {
            "head": "ディスク・ホイールの取付",
            "key": "tire_disc_wheel_installation",
        },
        {
            "head": "空気圧",
            "key": "tire_air_pressure",
        },
        {
            "head": "亀裂・損傷",
            "key": "tire_crack_damage",
        },
        {
            "head": "異常摩耗",
            "key": "tire_abnormal_wear",
        },
    ];

    const tableVehicleInspectionsDate03 = [
        {
            "head": "凝水",
            "key": "water_condensation",
        },
    ];

    const tableVehicleInspectionsDate04 = [
        {
            "head": "踏みしろ及び効き",
            "key": "brake_stepping_on_and_effectiveness",
        },
        {
            "head": "ブレーキ液の量",
            "key": "brake_amount_of_brake_fluid",
        },
        {
            "head": "空気圧力",
            "key": "brake_air_pressure",
        },
        {
            "head": "バブルからの排気音",
            "key": "brake_exhaust_sound_from_the_valve",
        },
        {
            "head": "駐車ブレーキ・レバーの引きしろ",
            "key": "brake_parking_brake_lever_pull",
        },
    ];

    const tableVehicleInspectionsDate05 = [
        {
            "head": "かかり具合・異音",
            "key": "depth_abnormal_noise",
        },
    ];

    const tableVehicleInspectionsDate06 = [
        {
            "head": "走行距離",
            "key": "end_mileage",
        },
    ];

    const tableVehicleInspectionsDate07 = [
        {
            "head": "アジテータ内部の付着物",
            "key": "agitator_internal_deposits",
        },
    ];

    const tableVehicleInspectionsMonth = [
        {
            "head": "冷却水の量",
            "key": "amount_of_cooling_water",
        },
        {
            "head": "ファン・ベルトの張り具合、損傷",
            "key": "fan_belt_tension",
        },
        {
            "head": "エンジン・オイルの量",
            "key": "engine_oil_quantity",
        },
        {
            "head": "バッテリー液の量",
            "key": "battery_fluid_level",
        },
        {
            "head": "タイヤの溝の深さ",
            "key": "tire_groove_depth",
        },
        {
            "head": "ウォッシャー液量及び噴射状態",
            "key": "washer_fluid_volume_and_injection_status",
        },
        {
            "head": "ワイパーの払拭状態",
            "key": "wiper_wipe_state",
        },
    ];

    export default {
        "filters": {
            changeFormatValue(val) {
                // valueの表示形式を変更
                if (val === "1") {
                    return "〇";
                } else if (val === "0") {
                    return "✕";
                } else {
                    return val;
                }
            },
            changeFormatMileage(val) {
                // 走行距離の表示形式を変更
                const decimalPoint = (`00${val}`.slice(-6) / 1000).toFixed(1);
                if (val) {
                    return decimalPoint;
                } else {
                    return "";
                }
            },
        },
        "mixins": [
            common,
            sorts,
            pdf,
        ],
        data() {
            return {
                "financialMonth": "",
                "lastDay": "",
                "listVehicles": [],
                "listVehicleInspections": {},
                "listVehicleInspectionsDate": {},
                "listVehicleInspectionsMonth": {},
                "params": {
                    "month": "",
                    "id": "",
                },
                "stamp": {
                    "plantManager": "mizutani",
                    "sectionChief1": "mizutani",
                    "sectionChief2": "mizutani",
                },
                "sync": {
                    "vehicles": "",
                },
                "tableSet": {
                    "dateItem01": tableVehicleInspectionsDate01,
                    "dateItem02": tableVehicleInspectionsDate02,
                    "dateItem03": tableVehicleInspectionsDate03,
                    "dateItem04": tableVehicleInspectionsDate04,
                    "dateItem05": tableVehicleInspectionsDate05,
                    "dateItem06": tableVehicleInspectionsDate06,
                    "dateItem07": tableVehicleInspectionsDate07,
                    "month": tableVehicleInspectionsMonth,
                },
            };
        },
        async created() {
            this.setDate();
            this.fetchingListVehicles();
            const vehicles = await this.sync.vehicles;
            this.fetchingListVehicleInspections(vehicles);
        },
        "methods": {
            getDateValue(data) {
                // dateを取得
                const date = data ? new Date(data) : new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const zero = (number) => {
                    return ("0" + number).slice(-2);
                };
                return {
                    "date": date,
                    "YYYY": year,
                    "M": month,
                    "D": day,
                    "MM": zero(month),
                    "DD": zero(day),
                    "normal": `${year}${zero(month)}${zero(day)}`,
                    "jp": `${year}年${zero(month)}月${zero(day)}日`,
                    "db": `${year}-${zero(month)}-${zero(day)}`,
                    "dot": `${year}.${zero(month)}.${zero(day)}`,
                    "slash": `${year}/${zero(month)}/${zero(day)}`,
                    "financialMonth": `${year}年${zero(month)}月度`,
                };
            },
            setDate() {
                // 今日の日付から今月をset
                this.params.month = `${this.getDateValue().YYYY}-${this.getDateValue().MM}`;
            },
            setLastDay() {
                // 月末日をset
                const last = new Date(this.getDateValue(this.params.month).YYYY, this.getDateValue(this.params.month).MM, 0);
                this.lastDay = last.getDate();
                this.setListVehicleInspectionsDate();
            },
            setListVehicleInspectionsDate() {
                // 日別点検リストをset
                this.listVehicleInspectionsDate = {};
                for (let i = 1; i <= this.lastDay; i++) {
                    const date = ("0" + i).slice(-2);
                    const fullDate = `${this.params.month}-${date}`;
                    this.listVehicleInspectionsDate[fullDate] = this.addVehicleInspectionsDate(fullDate);
                }
            },
            addVehicleInspectionsDate(fullDate) {
                // 日別点検データを追加
                let data = {
                    "inspection_date": "",
                    "lighting_or_blinking": "",
                    "tire_disc_wheel_installation": "",
                    "tire_air_pressure": "",
                    "tire_crack_damage": "",
                    "tire_abnormal_wear": "",
                    "water_condensation": "",
                    "agitator_internal_deposits": "",
                    "brake_stepping_on_and_effectiveness": "",
                    "brake_amount_of_brake_fluid": "",
                    "brake_air_pressure": "",
                    "brake_exhaust_sound_from_the_valve": "",
                    "brake_parking_brake_lever_pull": "",
                    "depth_abnormal_noise": "",
                    "start_mileage": "",
                    "end_mileage": "",
                };
                for (let i in this.listVehicleInspections.date) {
                    const inspectionDate = this.listVehicleInspections.date[i].inspection_date;
                    if (fullDate === inspectionDate) {
                        data = this.listVehicleInspections.date[i];
                    }
                }
                return data;
            },
            setListVehicleInspectionsMonth() {
                // 月別点検リストをset
                this.listVehicleInspectionsMonth = {};
                const dateSplit = this.params.month.split("-");
                const year = dateSplit[0];
                for (let i = 1; i <= 12; i++) {
                    const month = ("0" + i).slice(-2);
                    const fullMonth = `${year}-${month}`;
                    this.listVehicleInspectionsMonth[fullMonth] = this.addVehicleInspectionsMonth(fullMonth);
                }
            },
            addVehicleInspectionsMonth(fullMonth) {
                // 月別点検データを追加
                let data = {
                    "inspection_date": "",
                    "amount_of_cooling_water": "",
                    "fan_belt_tension": "",
                    "engine_oil_quantity": "",
                    "battery_fluid_level": "",
                    "tire_groove_depth": "",
                    "washer_fluid_volume_and_injection_status": "",
                    "wiper_wipe_state": "",
                };
                for (let i in this.listVehicleInspections.month) {
                    const dateSplit = this.listVehicleInspections.month[i].inspection_date.split("-");
                    const inspectionMonth = `${dateSplit[0]}-${dateSplit[1]}`;
                    if (fullMonth === inspectionMonth) {
                        data = this.listVehicleInspections.month[i];
                    }
                }
                return data;
            },
            pdfDownload() {
                const tableDate01 = [];
                const tableDate02 = [];
                const tableDate03 = [];
                const tableDate04 = [];
                const tableDate05 = [];
                const tableDate06 = [];
                const tableDate07 = [];
                const tableMonth = [];
                const tableHeadWidth = [];
                // テーブルを生成
                tableDate01[0] = [];
                tableDate02[0] = [];
                tableDate03[0] = [];
                tableDate04[0] = [];
                tableDate05[0] = [];
                tableDate06[0] = [];
                tableDate07[0] = [];
                tableMonth[0] = [];
                // 日別点検 thに日付を追加
                const addDateHeader = (headText,tableDate) => {
                    tableDate[0].push(headText);
                    for (let i = 1; i <= this.lastDay; i++) {
                        tableDate[0].push({
                            "text": i,
                            "alignment": "center",
                        });
                    }
                };
                // 日別点検 tdを追加（複数行対応）
                const addDateData = (dateItem, tableDate) => {
                    for (let item of dateItem) {
                        const tr = [];
                        tr.push(item.head);
                        for (let dateData in this.listVehicleInspectionsDate) {
                            const data = this.listVehicleInspectionsDate[dateData][item.key];
                            if (data === "1") {
                                tr.push({
                                    "text": "〇",
                                    "alignment": "center",
                                });
                            } else if (data === "0") {
                                tr.push({
                                    "text": "X",
                                    "alignment": "center",
                                });
                            } else {
                                tr.push(data);
                            }
                        }
                        tableDate.push(tr);
                    }
                };

                // 日別点検 項目名1を追加
                addDateHeader("車両の周り 灯火装置・方向指示器", tableDate01);
                // 日別点検 項目1のtdを追加（複数行対応）
                addDateData(this.tableSet.dateItem01, tableDate01);

                // 日別点検 項目名2を追加
                addDateHeader("タイヤ", tableDate02);
                // 日別点検 項目2のtdを追加（複数行対応）
                addDateData(this.tableSet.dateItem02, tableDate02);

                // 日別点検 項目名3を追加
                addDateHeader("エア・タンク", tableDate03);
                // 日別点検 項目3のtdを追加（複数行対応）
                addDateData(this.tableSet.dateItem03, tableDate03);

                // 日別点検 項目名7を追加
                addDateHeader("積載", tableDate07);
                // 日別点検 項目7のtdを追加（複数行対応）
                addDateData(this.tableSet.dateItem07, tableDate07);

                // 日別点検 項目名4を追加
                addDateHeader("運転席 ブレーキ", tableDate04);
                // 日別点検 項目4のtdを追加（複数行対応）
                addDateData(this.tableSet.dateItem04, tableDate04);

                // 日別点検 項目名5を追加
                addDateHeader("原動機", tableDate05);
                // 日別点検 項目5のtdを追加（複数行対応）
                addDateData(this.tableSet.dateItem05, tableDate05);

                // 日別点検 項目名6を追加
                addDateHeader("", tableDate06);
                // 日別点検 項目6のtdを追加（複数行対応）
                for (let item of this.tableSet.dateItem06) {
                    const tr = [];
                    tr.push(`${item.head}(千km)`);
                    for (let dateData in this.listVehicleInspectionsDate) {
                        const decimalPoint = (`00${this.listVehicleInspectionsDate[dateData][item.key]}`.slice(-6) / 1000).toFixed(1);
                        if (this.listVehicleInspectionsDate[dateData][item.key]) {
                            tr.push(decimalPoint);
                        } else {
                            tr.push("");
                        }
                    }
                    tableDate06.push(tr);
                }

                // 月別点検 thに日付を追加
                tableMonth[0].push("");
                for (let i = 1; i <= 12; i++) {
                    tableMonth[0].push({
                        "text": i,
                        "alignment": "center",
                    });
                }
                // 月別点検 tdを追加（複数行対応）
                for (let item of this.tableSet.month) {
                    const tr = [];
                    tr.push(item.head);
                    for (let monthData in this.listVehicleInspectionsMonth) {
                        const data = this.listVehicleInspectionsMonth[monthData][item.key];
                        if (data === "1") {
                            tr.push({
                                "text": "〇",
                                "alignment": "center",
                            });
                        } else if (data === "0") {
                            tr.push({
                                "text": "X",
                                "alignment": "center",
                            });
                        } else {
                            tr.push(data);
                        }
                    }
                    tableMonth.push(tr);
                }

                // 日別点検 日数+見出し分のwitdhを追加
                tableHeadWidth.push(45);
                for (let i = 0; i < this.lastDay; i++) {
                    if (this.lastDay === 31) {
                        tableHeadWidth.push(8);
                    } else {
                        tableHeadWidth.push(8.8);
                    }
                }

                // 横向きでPDFをリセット
                this.$_resetPdf({
                    "pageOrientation": "landscape", 
                });
                // PDFにタイトル・テキスト・サイン用テーブルを追加
                this.$_addPdfContent({
                    "table": {
                        "body": [
                            [
                                {
                                    "stack": [
                                        {
                                            "text": `車両点検日 (${this.getDateValue(this.params.month).financialMonth})`,
                                            "style": "title",
                                        },
                                        {
                                            "text": `車両ID: ${this.params.id}`,
                                            "style": "text",
                                        },
                                    ],
                                },
                                {
                                    "table": {
                                        "body": [
                                            [
                                                {
                                                    "text": "工場長",
                                                    "alignment": "center",
                                                },
                                                {
                                                    "text": "課長",
                                                    "alignment": "center",
                                                },
                                                {
                                                    "text": "係長",
                                                    "alignment": "center",
                                                },
                                            ],
                                            [
                                                {
                                                    "image": stamp[this.stamp.plantManager],
                                                    "width": 35,
                                                    "alignment": "center",
                                                    "margin": [0, 3, 0, 0],
                                                },
                                                {
                                                    "image": stamp[this.stamp.sectionChief1],
                                                    "width": 35,
                                                    "alignment": "center",
                                                    "margin": [0, 3, 0, 0],
                                                },
                                                {
                                                    "image": stamp[this.stamp.sectionChief2],
                                                    "width": 35,
                                                    "alignment": "center",
                                                    "margin": [0, 3, 0, 0],
                                                },
                                            ],
                                        ],
                                        "heights": [15, 40],
                                        "widths": [50, 50, 50],
                                    },
                                    "style": "table",
                                },
                            ],
                        ],
                        "widths": ["*", "auto"],
                    },
                    "layout": "noBorders",
                    "margin": [0, 0, 0, 30],
                });
                // PDFに日別点検テーブル01を追加
                this.$_addPdfContent({
                    "table": {
                        "widths": tableHeadWidth,
                        "body": tableDate01,
                    },
                    "layout": "lightHorizontalLines",
                    "margin": [0, 0, 0, 10],
                    "style": "tableVehicleInspections",
                });
                // PDFに日別点検テーブル02を追加
                this.$_addPdfContent({
                    "table": {
                        "widths": tableHeadWidth,
                        "body": tableDate02,
                    },
                    "layout": "lightHorizontalLines",
                    "margin": [0, 0, 0, 10],
                    "style": "tableVehicleInspections",
                });
                // PDFに日別点検テーブル03を追加
                this.$_addPdfContent({
                    "table": {
                        "widths": tableHeadWidth,
                        "body": tableDate03,
                    },
                    "layout": "lightHorizontalLines",
                    "margin": [0, 0, 0, 10],
                    "style": "tableVehicleInspections",
                });
                // PDFに日別点検テーブル07を追加
                this.$_addPdfContent({
                    "table": {
                        "widths": tableHeadWidth,
                        "body": tableDate07,
                    },
                    "layout": "lightHorizontalLines",
                    "margin": [0, 0, 0, 10],
                    "style": "tableVehicleInspections",
                });
                // PDFに日別点検テーブル04を追加
                this.$_addPdfContent({
                    "table": {
                        "widths": tableHeadWidth,
                        "body": tableDate04,
                    },
                    "layout": "lightHorizontalLines",
                    "margin": [0, 0, 0, 10],
                    "style": "tableVehicleInspections",
                });
                // PDFに日別点検テーブル05を追加
                this.$_addPdfContent({
                    "table": {
                        "widths": tableHeadWidth,
                        "body": tableDate05,
                    },
                    "layout": "lightHorizontalLines",
                    "margin": [0, 0, 0, 10],
                    "style": "tableVehicleInspections",
                });
                // PDFに日別点検テーブル06を追加
                this.$_addPdfContent({
                    "table": {
                        "widths": tableHeadWidth,
                        "body": tableDate06,
                    },
                    "layout": "lightHorizontalLines",
                    "margin": [0, 0, 0, 30],
                    "style": "tableVehicleInspections",
                });
                // PDFに月別点検テーブルを追加
                this.$_addPdfContent({
                    "table": {
                        "widths": tableHeadWidth,
                        "body": tableMonth,
                    },
                    "layout": "lightHorizontalLines",
                    "style": "tableVehicleInspections",
                });
                // PDFを出力
                this.$_pdfDownload(`車両点検日（${this.getDateValue(this.params.month).financialMonth}）`);
            },
            fetchingListVehicles() {
                // 全車両データ取得
                this.sync.vehicles = common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicles`,
                    this.$_requestConfig()
                ).then(response => {
                    // 車両IDで昇順
                    this.listVehicles = response.data.sort((a, b) => a.vehicle_id - b.vehicle_id);
                    this.params.id = this.listVehicles[0].vehicle_id;
                }).catch(() => {
                    this.$_modalError("fetchingVehiclesError");
                });
            },
            fetchingListVehicleInspections() {
                this.$_requestCancel("SelectDate");
                // 車両点検詳細データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicle_inspection_detail`,
                    this.$_requestConfig("SelectDate")
                ).then(response => {
                    this.listVehicleInspections = response.data;
                    this.setLastDay();
                    this.setListVehicleInspectionsMonth();
                }).catch(() => {
                    this.$_modalError("fetchingVehicleInspectionsError");
                });
            },
            goToUpdate(i) {
                this.$router.push({
                    "name": "offices_vehicle_inspections_update",
                    "params": {
                        "id": String(this.params.id),
                        "date": String(this.params.month + "-" + ("0" + i).slice(-2)),
                    },
                });
            },
            goToUpdateMonth(i) {
                this.$router.push({
                    "name": "offices_vehicle_inspections_update_month",
                    "params": {
                        "id": String(this.params.id),
                        "month": String(this.params.month.slice(0, 5) + ("0" + i).slice(-2)),
                    },
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .dashboard table tr th:first-child,
    .dashboard table tr td:first-child {
        padding: 8px;
        width: 17%;
    }
    .dashboard table tr th,
    .dashboard table tr td {
        font-size: 13px;
        padding: 8px 4px;
        white-space: normal;
        width: 44px;
    }
</style>
